import { io } from "socket.io-client";

const { REACT_APP_REST_URL } = process.env;
// Socket.IO connects to the server's root, not the REST API's /api path.
const SOCKET_URL = (REACT_APP_REST_URL || "").replace(/\/api\/?$/, "");

const TOKEN_KEY = "cbrne_token";

let socket = null;

// Lazily creates (or returns the existing) socket connection, authenticated with the
// same JWT httpClient sends as a Bearer header — see server src/realtime/socket.js.
function getSocket() {
    if (socket) return socket;
    const token = localStorage.getItem(TOKEN_KEY);
    socket = io(SOCKET_URL, {
        auth: { token },
        autoConnect: false,
    });
    return socket;
}

// Called from AuthService.login() once a fresh token exists.
export function connectSocket() {
    const s = getSocket();
    if (s.auth?.token !== localStorage.getItem(TOKEN_KEY)) {
        // Token changed (re-login as a different user) — force a fresh handshake
        // rather than reusing a connection authenticated as someone else.
        s.auth = { token: localStorage.getItem(TOKEN_KEY) };
    }
    if (!s.connected) s.connect();
    return s;
}

// Called from AuthService.logout().
export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}

export default getSocket;
